module.exports = __webpack_public_path__ + "france.svg?968aaa24eeffdd779e4fc9c27c5cb730";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/france.svg
// module id = 167
// module chunks = 10